/**
 * DesktopTitleBar — frameless titlebar, Electron-only.
 *
 * Renders the draggable title region for the Electron host (the native window
 * is frameless with OS controls overlaid via titleBarOverlay). On web and mobile
 * this returns null, so the same tree is safe everywhere.
 *
 * The drag region uses the WebkitAppRegion style (Electron-recognised). Square
 * corners, tokens only — design system is platform-invariant (DESIGN.md).
 */
import * as React from "react";
import { usePlatform } from "@omni/client-platform";

// `WebkitAppRegion` is an Electron-only CSS extension not in the standard
// CSSProperties type; widen via `unknown` so the cast is sound.
const DRAG_REGION = { WebkitAppRegion: "drag" } as unknown as React.CSSProperties;

export function DesktopTitleBar() {
  const { host, os } = usePlatform();
  if (host !== "electron") return null;

  // Leave room for the macOS traffic lights on the left.
  const leftInset = os === "macos" ? "pl-20" : "pl-3";

  return (
    <div
      className={`flex h-11 shrink-0 items-center ${leftInset} bg-bg border-b border-border select-none`}
      style={DRAG_REGION}
    >
      <span className="text-xs font-mono tracking-wide text-fg-muted">OMNI</span>
    </div>
  );
}
